import { render, staticRenderFns } from "./TwinHighwayIntro.vue?vue&type=template&id=95c05f40&scoped=true&"
import script from "./TwinHighwayIntro.vue?vue&type=script&lang=js&"
export * from "./TwinHighwayIntro.vue?vue&type=script&lang=js&"
import style0 from "./TwinHighwayIntro.vue?vue&type=style&index=0&id=95c05f40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c05f40",
  null
  
)

export default component.exports